import React from 'react'
import BaseInput from '../../General/FormsComp/Input/BaseInput';

// Componente ObservacaoCadastro para uso na aba de observação do cliente
const ObservacaoCadastro = ({ newClient, handleInputChange }) => (
    <div className="p-8 mx-auto max-w-4xl w-3/4">
        <BaseInput
            label="Observações"
            name="observacoes"
            value={newClient.observacoes || ''}
            onChange={handleInputChange}
            type="textarea"
            rows={6}
            placeholder="Digite observações relevantes sobre o cliente..."
        />
    </div>
);

export default ObservacaoCadastro;
